import React from "react";

import { DraggableIDsProvider } from "./DraggableIDsContext";
import { DragsHistoryProvider } from "./DragsHistoryContext";
import { IsDraggableProvider } from "./IsDraggableContext";

export const DraggableContextsWrapper = ({ isDraggableDefault=false, children, ...rest }) => (
	<IsDraggableProvider isDraggableDefault={isDraggableDefault}>
		<DraggableIDsProvider>
            <DragsHistoryProvider>
                {React.cloneElement(children, { ...rest })}
            </DragsHistoryProvider>
        </DraggableIDsProvider>
	</IsDraggableProvider>
);
